import { Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type { UtilizationReportGroupBy } from "@src/__generated__/urql-graphql";
import { DropdownButton } from "@src/components/ui-kit";
import { Fragment } from "react";

type GroupByOption = {
  readonly value: UtilizationReportGroupBy;
  readonly label: string;
};

type GroupByMenuProps = {
  readonly activeGroupByOption?: GroupByOption;
  readonly groupByOptions: readonly GroupByOption[];
  readonly onGroupByChange: (
    value: UtilizationReportGroupBy | undefined,
  ) => void;
  readonly onResetPage: () => void;
};

export const GroupByMenu = ({
  activeGroupByOption,
  groupByOptions,
  onGroupByChange,
  onResetPage,
}: GroupByMenuProps) => {
  return (
    <Menu>
      <MenuButton
        as={DropdownButton}
        sx={
          activeGroupByOption
            ? {
                bg: "riptide.50",
                borderColor: "riptide.400",
                _hover: {
                  bg: "riptide.100",
                },
                _active: {
                  bg: "riptide.100",
                },
              }
            : undefined
        }
      >
        <Trans>Group By</Trans>
        {!!activeGroupByOption && (
          <Fragment>
            <span>:</span>
            <Text as="span" ml="1" color="blue.500">
              {activeGroupByOption.label}
            </Text>
          </Fragment>
        )}
      </MenuButton>
      <MenuList>
        {groupByOptions.map(({ value, label }) => (
          <MenuItem
            key={value}
            onClick={() => {
              onGroupByChange(value);
              onResetPage();
            }}
          >
            {label}
          </MenuItem>
        ))}
        {!!activeGroupByOption && (
          <MenuItem
            onClick={() => {
              onGroupByChange(undefined);
              onResetPage();
            }}
          >
            <Trans>None</Trans>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};
